/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Browser_ClickInputs */



/**
* | output |
* | --- |
* | "Clicking on page" |
*
* @param {Chat_Tool_Browser_ClickInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_browser_click = /** @type {((inputs?: Chat_Tool_Browser_ClickInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Browser_ClickInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Klick auf Seite")
	return /** @type {LocalizedString} */ ("Clicking on page")
});